/**
 * @file ステッパーの高さ設定
 */
'use strict';

/**
 * @classname SetStepperHeight
 * @classdesc ステッパーの高さ設定
 */
export default class SetStepperHeight {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('SetStepperHeight.constructor');
		this._$e = $e;
		const height = $('.stepper').length * 70;
		console.log(height);
		$('body').css('padding-top', `${height}px`);
		$('.c-sidebar.c-sidebar-fixed').css('top', `${height}px`);
		$('.c-main').css('padding-bottom', '50px');
		this._addSpan = false;
		setTimeout(() => this.setListWidth(), 300);
		$(window).on('resize', () => this.setListWidth());
	};

	/**
	 * クリックコールバック
	 *
	 * @memberof SetStepperHeight
	 */
	setListWidth() {
		console.log('SetStepperHeight.setListWidth');
		const $list = this._$e.find('.list');
		let width = $list.width();
		let width2 = (width - 200) / 5;
		width2 = Math.floor(width2);
		width = width2 * 5 + 200;
		console.log(width);
		$list.css('width', `${width}px`);
		if (!this._addSpan) {
			$list.find('.list-item').append('<span></span>');
			this._addSpan = true;
		}
	};
}
